
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CodeInput extends Vue {
  @Prop({ default: () => [] }) code!: Array<string>; // 接收一个可以改变父组件的数据(引用类型才可以修改,所以这里是引用类型)
  @Prop({ default: () => () => {} }) success!: Function; // 用户输入完成后的回调
  @Prop({ default: () => () => {} }) error!: Function; // 用户输入错误的时候调用的函数
  @Prop({ default: () => () => {} }) getInput!: Function; // 每次输入都回调
  @Prop({ default: '20px' }) spanSize!: string; // 显示字体大小
  @Prop({ default: '#3C4043' }) spanColor!: string; // 显示字体颜色
  @Prop({ default: '20px' }) inputSize!: string; // 输入的字体大小
  @Prop({ default: '#3C4043' }) inputColor!: string; // 显示字体颜色
  @Prop({ default: '40px' }) height!: string;
  @Prop({ default: 6 }) number!: number; // 验证码个数
  @Prop({
    default: 'text',
    validator(value: any): boolean {
      return ['number', 'text'].indexOf(value) > -1;
    }
  })
  type!: String; //验证码个数
  @Prop({ default: true }) upperCase!: boolean;

  private inputCodeNum: number = 0; // 输入框的位置
  private left: string = '0'; // 输入框距离左边的距离
  private inputCode: any = ''; // 单次输入的值
  private codeArray: Array<any> = []; // 输入的值数组
  private blockWidth: string = (100 / this.number).toFixed(4) + '%'; //每个格子的宽度
  private blockSize: any = (100 / this.number).toFixed(4); //计算用宽度
  private block: Array<any> = []; // 存放格子
  private zIndex: number = 1; // 输入框层级(开始默认最高)

  get codeString(): string {
    let data = '';
    this.codeArray.map(item => {
      data += item;
    });
    return data;
  }
  created() {
    for (let i = 0; i < this.number; i++) {
      this.block.push(i); //获取格子数并保持方便循环
    }
  }
  // 删除输入
  deleteInput() {
    if (this.inputCodeNum === this.number - 1) {
      this.inputCodeNum--;
      this.left = this.blockSize * this.inputCodeNum + '%';
      this.codeArray.pop();
      this.code.pop();
      this.getInput(this.codeString);
      return;
    }
    if (this.inputCodeNum !== 0) {
      this.inputCodeNum--;
      this.codeArray.pop();
      this.code.pop();
      this.left = this.blockSize * this.inputCodeNum + '%';
      this.getInput(this.codeString);
    }
  }
  // 每次输入的事件
  inputCodeEvent(e: KeyboardEvent) {
    if (!this.inputCode) return;
    if (this.type === 'number' && isNaN(this.inputCode)) {
      // 要求输入数字类型
      if (!this.error(this.inputCode)) {
        // 没有返回或者返回false就清掉并退出
        this.inputCode = '';
        return;
      }
    }
    if (!/^[A-Za-z0-9]+$/.test(this.inputCode)) {
      this.inputCode = '';
      return;
    }
    // @ts-ignore
    if (e.key !== '' && e.key !== undefined && e.key !== 'Unidentified') {
      this.inputCode = e.key;
    } else {
      // @ts-ignore
      this.inputCode = e.target._value;
    }
    this.upperCase && (this.inputCode = this.inputCode.toUpperCase());
    if (this.inputCodeNum < this.number - 1) {
      this.codeArray.push(this.inputCode);
      this.code.push(this.inputCode);
      this.inputCode = '';
      this.inputCodeNum++;
      this.left = this.blockSize * this.inputCodeNum + '%';
      this.getInput(this.codeString);
      this.$forceUpdate();
    } else {
      if (this.inputCodeNum === this.number - 1) {
        this.inputCodeNum++;
        this.codeArray.push(this.inputCode);
        this.code.push(this.inputCode);
        this.success(this.codeString);
        this.getInput(this.codeString);
        // @ts-ignore
        this.$refs.input_code.blur();
        this.$forceUpdate();
      }
    }
  }
  // 失去焦点
  blurInput() {
    this.zIndex = -1;
  }
  // 获得焦点
  focusInput() {
    this.zIndex = 1;
    // @ts-ignore
    this.$refs.input_code.focus();
  }
}
